baseApp.service('RunningEventDiscoveryExportsService', ['$rootScope', function($rootScope) {

    let runningEventDiscoveryExportsService = {};

    var fetchData = function(callback) {
        store.fetch({
            path: '/discoverData/events/getRunningExportMap',
            success: function (data) {
                callback(data);
            }
        })
    };

    runningEventDiscoveryExportsService.getRunningExports = function(callback) {
        fetchData(function(data) {
            callback(data);
        });
    };

    runningEventDiscoveryExportsService.cancelJob = function(jobId, accountId, userId, callback) {
        $rootScope.confirm("Are you sure you want to cancel the job: " + jobId + " for account: " + accountId + " ?", function () {
            store.fetch({
                method: 'POST',
                path: '/discoverData/events/cancelExportBySystem',
                queryParams: { id: jobId, accountId: accountId, userId: userId},
                success: function(data) {
                    callback();
                }
            })}, 'Yes', 'No', null, null, null, null);
    };


    return runningEventDiscoveryExportsService;

}]);